/**
 *
 * MainModeBook
 *
 */

import _ from 'lodash';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Swal from 'sweetalert2';
import VueScrollTo from 'vue-scrollto';
import $ from 'jquery';

import TrackerButton from '@/components/TrackerButton.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import ToolBar from '@/components/ToolBar.vue';
import Footer from '@/components/Footer.vue';
import Player from '@/components/Player.vue';
import Spinner from '@/components/Spinner.vue';
import Challenge from '@/components/Question/Question.vue';
import Practice from '@/components/Question/Question.vue';
import CourseLevelUp from '@/components/CourseLevelUp.vue';
import BookMasterAchieved from '@/components/BookMasterAchieved.vue';
import ButtonBookAllFile from '@/components/ButtonBookAllFile.vue';
import StudentworkModal from '@/components/StudentworkModal.vue';
import { ClassRestrictionMixin } from '@/mixins/ClassRestriction';
import { OpenStudentworkModalMixin } from '@/mixins/Studentwork/OpenStudentworkModal';

//import { IDENTITY_PAGE } from '@/constants/routes';
import {
  getLevelText,
  triggerFireworks,
  triggerShoolPride,
  getDurationString,
} from '../../../utils';
import { LOADING_MESSAGE, BOOK_MASTER_LEVEL } from './MainModeBook.constants';

export default {
  name: 'MainModeBook',

  mixins: [ClassRestrictionMixin, OpenStudentworkModalMixin],

  components: {
    WayFindBar,
    ToolBar,
    Footer,
    Player,
    Challenge,
    Practice,
    Spinner,
    CourseLevelUp,
    BookMasterAchieved,
    ButtonBookAllFile,
    TrackerButton,
    StudentworkModal,
  },

  data() {
    return {
      currentComponent: 'practice',
      isShowPlayer: false,
      currentVideo: {},
      loadingMessage: LOADING_MESSAGE,
      questionTitle: '',
      isShowPractice: false,
      isShowChallenge: false,
      isShowBookMasterAchieved: false,
      isShowCourseLevelUp: false,
      clearType: '',
      currentSubjectId: '',
      currentFocusedSubjectId: '',
      currentReadingId: '',
      generating: false,
      scrolledToChallengeButton: false,
      hideCurrentBtn: false,
      currentFileIdx: -1,
      promiseFetchBook: null,

      popoverId: '',
    };
  },

  computed: {
    ...mapState({
      ms_isSetGotoLastStudy: 'isSetGotoLastStudy',
      ms_isDebug: 'isDebug',
    }),

    ...mapGetters({
      Book: 'MainModeBook/Book',
      BasisVideos: 'MainModeBook/BasisVideos',
      ReinforceVideos: 'MainModeBook/ReinforceVideos',
      ClassicVideos: 'MainModeBook/ClassicVideos',
      ReviewVideos: 'MainModeBook/ReviewVideos',
      userInfo: 'userInfo',
      ReadyToPlayVideos: 'MainModeBook/ReadyToPlayVideos',
      immLoading: 'immLoading',
      QuestionList: 'MainModeBook/QuestionList',
      Question: 'MainModeBook/Question',
      BeforePracticeData: 'MainModeBook/BeforePracticeData',
      AfterPracticeData: 'MainModeBook/AfterPracticeData',
      BeforeChallengeData: 'MainModeBook/BeforeChallengeData',
      AfterChallengeData: 'MainModeBook/AfterChallengeData',
      isRequest: 'MainModeBook/isRequest',
      hasCurrentReading: 'MainModeBook/hasCurrentReading',
      lastTimeGroupBulletId: 'MainModeBook/lastTimeGroupBulletId',
      isBookLevelUp: 'MainModeBook/isBookLevelUp',
      isCourseLevelUp: 'MainModeBook/isCourseLevelUp',
      bookLevelUpTo: 'MainModeBook/bookLevelUpTo',
      courseLevelUpTo: 'MainModeBook/courseLevelUpTo',
      books: 'MainModeBook/books',
      isHideFileDownLoadTip: 'MainModeBook/isHideFileDownLoadTip',
      isInReview: 'MainModeBook/isInReview',
      isLockedByStudentWorkStatus: 'MainModeBook/isLockedByStudentWorkStatus',
    }),

    CourseId: function () {
      return this.$route.params.courseId;
    },

    ///
    c_courseId() {
      return Number(this.CourseId);
    },

    BookId: function () {
      return this.$route.params.bookId;
    },

    ReadingId: function () {
      return this.$route.params.readingId ? this.$route.params.readingId : '';
    },

    //c_isNoAuth() {
    //  return Boolean(this.userInfo.authenticated === -1) && Boolean(this.userInfo.hasPay);
    //},

    c_isCpaCourse: function () {
      return 'cpa' === this.Book.mallCategory;
    },

    c_isShowBulletUpdateList() {
      return this.Book.bulletUpdateList && this.Book.bulletUpdateList.length > 0;
    },

    c_isShowBookPointsUpdateList() {
      return (
        this.Book.bookPointsUpdateList &&
        (this.Book.bookPointsUpdateList.newPoints > 0 ||
          this.Book.bookPointsUpdateList.deletePoints > 0)
      );
    },

    c_isShowUpdateListBtn() {
      return this.c_isShowBulletUpdateList || this.c_isShowBookPointsUpdateList;
    },

    c_isClassicQuestionPractice() {
      return 'classic-question-practice' === this.currentComponent;
    },

    c_practiceType() {
      return this.c_isClassicQuestionPractice ? 8 : 11;
    },

    c_isShowFilter() {
      return !this.c_isClassicQuestionPractice;
    },

    c_hasBefore() {
      return !this.c_isClassicQuestionPractice;
    },

    c_hasAfter() {
      return !this.c_isClassicQuestionPractice;
    },

    ///
    c_restrictStudent() {
      return this.Book.restrictStudent;
    },
  },

  created() {
    this._mainModeBookCreated();
  },

  mounted() {
    this._mainModeBookMounted();
  },

  beforeDestroy() {
    this._mainModeBookBeforeDestroy();
  },

  methods: {
    ...mapMutations({
      mm_SET_GOTO_LAST_STUDY: 'SET_GOTO_LAST_STUDY',
    }),

    ...mapActions({
      getBook: 'MainModeBook/getBook',
      addToFavoriteList: 'MainModeBook/addToFavoriteList',
      noteSaved: 'MainModeBook/noteSaved',
      getBeforeChallenge: 'MainModeBook/getBeforeChallenge',
      getAfterChallenge: 'MainModeBook/getAfterChallenge',
      tsChallenge: 'MainModeBook/tsChallenge',
      getChallenge: 'MainModeBook/getChallenge',
      ma_setIsInReview: 'MainModeBook/setIsInReview',
      getBeforePractice: 'MainModeBook/getBeforePractice',
      getAfterPractice: 'MainModeBook/getAfterPractice',
      getPractice: 'MainModeBook/getPractice',
      getQuestionListType: 'MainModeBook/getQuestionListType',
      answer: 'MainModeBook/answer',
      getQuestion: 'MainModeBook/getQuestion',
      markQuestion: 'MainModeBook/markQuestion',
      generateFile: 'MainModeBook/generateFile',
    }),

    changeBulletStatus(video, status) {
      this.$store.commit('MainModeBook/SET_BULLET_STATUS', { video, status });
    },

    setLastProgress(videoId, payload) {
      this.$store.commit('MainModeBook/SET_LAST_PROGRESS', { videoId, payload });
    },

    goBack() {
      this.$router.go(-1);
    },

    async fetchBook() {
      await this.getBook(this.BookId);
      $(function () {
        $('[data-toggle="popover"]').popover();
      });
      if (this.ReadingId) {
        VueScrollTo.scrollTo(`#readingGroup-${this.ReadingId}`, 1000, {
          container: '.webapp-layout-main',
          easing: 'linear',
          offset: -150,
          onDone: () => {
            this.currentReadingId = this.ReadingId;
            setTimeout(() => {
              this.currentReadingId = '';
            }, 1000);
          },
        });
      }
    },

    getBtnTxt(status, isCurrent, subjectId) {
      if (status === 0) {
        if (isCurrent || this.currentSubjectId == subjectId) {
          return '已开始';
        } else {
          return '练习';
        }
      } else if (status === -1) {
        return '再试一次';
      } else if (status === 1) {
        return '再试一次';
      }
    },

    hidePopover(e) {
      if (this.popoverId && !e.target.classList.contains('ofLblSelectVideoType')) {
        $(`#${this.popoverId}`).popover('hide');
        this.popoverId = '';
      }
    },

    async selectVideoType(payload) {
      if (this.popoverId && this.popoverId !== payload.labelId) {
        $(`#${this.popoverId}`).popover('hide');
      }
      this.$store.commit('MainModeBook/CHANGE_VIDEO_TYPE', payload);
      if (!payload.canAccess) {
        this.popoverId = payload.labelId;
        $(`#${this.popoverId}`).popover('show');
      } else {
        await this.$nextTick();
        const trkbtn = _.find(
          this.$refs.trkbtnOpenPlayers,
          (trkbtnOpenPlayer) =>
            `trkbtn-group-${payload.groupId}-bullet-${payload.bulletId}` ===
            trkbtnOpenPlayer.$options.propsData.extraId
        );
        trkbtn.$refs.btn.click();
      }
    },

    openPlayer(bullet, groupId) {
      this.$store.commit('MainModeBook/CHANGE_GROUP', {
        bulletId: bullet.bulletId,
        groupId,
      });
      this.currentVideo = this.ReadyToPlayVideos.find((v) => v.bulletId == bullet.bulletId);
      this.isShowPlayer = true;
    },

    closePlayer() {
      this.isShowPlayer = false;
    },

    goToNextVideo() {
      const index = _.findIndex(this.ReadyToPlayVideos, this.currentVideo);
      this.currentVideo = this.ReadyToPlayVideos[index + 1];
    },

    go2Challenge() {
      if (this.Book.freeMode) {
        Swal.fire({
          width: '400px',
          icon: 'info',
          title: `体验课程无法参加挑战`,
          text: '亲爱的学员请购买后再参加挑战!',
          showConfirmButton: true,
          confirmButtonText: '知道啦',
        });
        return;
      }
      if (!this.Book.hasQuestionLib) {
        Swal.fire({
          width: '400px',
          icon: 'info',
          title: `非考证班无法参加挑战`,
          text: '您当前的班型没有此功能的权限，可补差价升级后开启!',
          showConfirmButton: true,
          confirmButtonText: '知道啦',
        });
        return;
      }
      if (!this.Book.videoComplete) {
        Swal.fire({
          width: '400px',
          icon: 'info',
          title: `该学科尚未更新完毕`,
          text: '待全部更新后即可进行学科挑战!',
          showConfirmButton: true,
          confirmButtonText: '知道啦',
        });
        return;
      }
      this.currentComponent = 'challenge';
      this.$nextTick(() => {
        this.isShowChallenge = true;
        this.getBeforeChallenge({ bookId: this.BookId });
      });
    },

    closeChallenge() {
      this.isShowChallenge = false;
      this.$store.commit('MainModeBook/UPDATE_SUBJECT_LIST_STATUS');
      if (this.isCourseLevelUp) {
        this.isShowCourseLevelUp = true;
        this.clearType = 'challenge';
        triggerShoolPride();
        this.resetCourseLevelUpStatus();
      } else if (this.isBookLevelUp && this.Book.bookLevel == BOOK_MASTER_LEVEL) {
        this.isShowBookMasterAchieved = true;
        this.clearType = 'challenge';
        triggerShoolPride();
        this.resetBookLevelUpStatus();
      } else {
        this.clearChallengeData();
      }
    },

    getChallengeData(type) {
      this.getChallenge({ bookId: this.BookId, courseId: this.CourseId, type });
    },

    setIsInReview(payload) {
      this.ma_setIsInReview({
        ...payload,
        courseId: this.CourseId,
      });
    },

    getAfterChallengeData() {
      this.getAfterChallenge({ bookId: this.BookId });
    },

    async tsChallengeData() {
      await this.tsChallenge({ bookId: this.BookId });
    },

    swalWarnNotHasQuestionLib() {
      Swal.fire({
        width: '400px',
        icon: 'info',
        title: `非考证班无法参加练习`,
        text: '您当前的班型没有此功能的权限，可补差价升级后开启!',
        showConfirmButton: true,
        confirmButtonText: '知道啦',
      });
    },

    go2Practice(subject) {
      if (!this.Book.hasQuestionLib) {
        this.swalWarnNotHasQuestionLib();
        return;
      }
      this.currentComponent = 'practice';
      this.$nextTick(() => {
        this.isShowPractice = true;
        this.questionTitle = `${subject.subjectName}练习`;
        this.currentSubjectId = subject.subjectId;
        this.getBeforePractice({ subjectId: subject.subjectId });
      });
    },

    go2ClassicQuestionPractice({ /* reading, subject, */ bullet }) {
      if (!this.Book.hasQuestionLib) {
        this.swalWarnNotHasQuestionLib();
        return;
      }
      this.currentComponent = 'classic-question-practice';
      this.isShowPractice = true;
      this.questionTitle = `${bullet.bulletName} 练习`;
      //this.currentSubjectId = subject.subjectId;
      //this.getBeforePractice({ subjectId: subject.subjectId });
      this.getQuestionListType({
        practiceType: 8,
        courseId: this.c_courseId,
        bookId: -1, //Number(this.BookId),
        readingId: -1, //reading.readingId,
        subjectId: -1, //subject.subjectId,
        bulletId: bullet.bulletId,
        inFilter: false,
        attribute: [],
        questionOrder: true,
        type: 5,
      });
    },

    closePractice() {
      this.isShowPractice = false;
      this.$store.commit('MainModeBook/UPDATE_SUBJECT_STATUS');
      if (this.isCourseLevelUp) {
        this.isShowCourseLevelUp = true;
        this.clearType = 'practice';
        triggerShoolPride();
        this.resetCourseLevelUpStatus();
        return;
      } else if (this.isBookLevelUp) {
        if (this.Book.bookLevel == BOOK_MASTER_LEVEL) {
          this.isShowBookMasterAchieved = true;
          this.clearType = 'practice';
          triggerShoolPride();
        } else {
          triggerFireworks();
          this.clearPracticeData();
        }
        this.resetBookLevelUpStatus();
        return;
      } else {
        this.clearPracticeData();
      }
    },

    resetBookLevelUpStatus() {
      _.delay(() => {
        this.$store.commit('MainModeBook/SET_BOOK_LEVEL_UP_STATUS', false);
      }, 3000);
    },

    resetCourseLevelUpStatus() {
      _.delay(() => {
        this.$store.commit('MainModeBook/SET_COURSE_LEVEL_UP_STATUS', false);
      }, 3000);
    },

    retryPractice() {
      this.$store.commit('MainModeBook/UPDATE_SUBJECT_STATUS');
      this.clearPracticeData();
      this.getPracticeData();
    },

    closeBookMasterAchieved() {
      this.isShowBookMasterAchieved = false;
      this.$store.commit('MainModeBook/SET_BOOK_LEVEL_UP_STATUS', false);
      if (this.clearType == 'practice') {
        this.clearPracticeData();
      }
      if (this.clearType == 'challenge') {
        this.clearChallengeData();
      }
      this.clearType = '';
    },

    closeCourseLevelUp() {
      this.isShowCourseLevelUp = false;
      this.$store.commit('MainModeBook/SET_COURSE_LEVEL_UP_STATUS', false);
      if (this.clearType == 'practice') {
        this.clearPracticeData();
      }
      if (this.clearType == 'challenge') {
        this.clearChallengeData();
      }
      this.clearType = '';
    },

    closeBookLevelUpTip() {
      this.$store.commit('MainModeBook/RESET_BOOK_POINTS');
    },

    getPracticeData() {
      this.getPractice({ subjectId: this.currentSubjectId, courseId: this.CourseId });
    },

    getAfterPracticeData() {
      this.getAfterPractice({ subjectId: this.currentSubjectId });
    },

    setQuestion(payload) {
      this.$store.commit('MainModeBook/SET_QUESTION', payload);
    },

    doChallengeAnswer(payload) {
      this.answer({ ...payload, inChallenge: true, courseId: Number.parseInt(this.CourseId) });
    },

    doPracticeAnswer(payload) {
      this.answer({ ...payload, courseId: Number.parseInt(this.CourseId) });
    },

    goToQuestion(questionId) {
      this.getQuestion({ courseId: Number.parseInt(this.CourseId), questionId });
    },

    async mark() {
      await this.markQuestion({
        courseId: Number.parseInt(this.CourseId),
      });

      Swal.fire({
        width: '400px',
        backdrop: false,
        icon: 'success',
        title: `${this.Question.isMarked ? '收藏成功' : '已取消收藏'}`,
        showConfirmButton: false,
        timer: 800,
      });
    },

    async markVideo(payload) {
      await this.addToFavoriteList(payload);
      Swal.fire({
        width: '400px',
        backdrop: false,
        icon: 'success',
        title: `${this.currentVideo.collected ? '收藏成功' : '已取消收藏'}`,
        showConfirmButton: false,
        timer: 800,
      });
    },

    getLevelText(currentLevel) {
      let nextLevelText = '';
      switch (currentLevel) {
        case 0:
          nextLevelText = '未了解';
          break;
        case 1:
          nextLevelText = '未了解';
          break;
        case 2:
          nextLevelText = '初步了解';
          break;
        case 3:
          nextLevelText = '熟悉';
          break;
        case 4:
          nextLevelText = '精通';
          break;
        default:
          nextLevelText = '';
      }
      return nextLevelText;
    },

    async generatePDF(file, idx) {
      this.generating = true;
      this.currentFileIdx = idx;
      await this.generateFile({
        courseId: this.CourseId,
        bookId: file.nodeId,
        fileId: file.fileId,
      });
      this.generating = false;
      this.currentFileIdx = -1;
    },

    getText(level) {
      return getLevelText(level);
    },

    openDownloadPanel() {
      $('#CourseFile').modal('show');
    },

    scrollToReading(readingId) {
      const context = this;
      setTimeout(() => {
        context.currentReadingId = readingId;
        setTimeout(() => {
          context.currentReadingId = '';
        }, 1000);
      }, 600);

      VueScrollTo.scrollTo(`#readingGroup-${readingId}`, 500, {
        container: '.webapp-layout-main',
        duration: 500,
        easing: 'linear',
        offset: -220,
      });
    },

    openLastTimeBullet() {
      const isHaveLastTimeBullet =
        -1 !== this.lastTimeGroupBulletId.groupId && -1 !== this.lastTimeGroupBulletId.bulletId;
      if (isHaveLastTimeBullet) {
        this.$nextTick(() => {
          const trkbtn = _.find(
            this.$refs.trkbtnOpenPlayers,
            (trkbtnOpenPlayer) =>
              `trkbtn-group-${this.lastTimeGroupBulletId.groupId}-bullet-${this.lastTimeGroupBulletId.bulletId}` ===
              trkbtnOpenPlayer.$options.propsData.extraId
          );
          if (trkbtn) {
            trkbtn.$refs.btn.click();
          }
        });
      }
    },

    gotoLastTimeReading(readingId) {
      this.hideCurrentBtn = true;
      this.scrollToReading(readingId);
      setTimeout(() => {
        this.openLastTimeBullet();
      }, 500);
    },

    scrollToSubject(subjectId) {
      const context = this;
      context.currentFocusedSubjectId = '';
      setTimeout(() => {
        context.currentFocusedSubjectId = subjectId;
        setTimeout(() => {
          context.currentFocusedSubjectId = '';
        }, 3000);
      }, 600);
    },

    scrollToChallenge() {
      const context = this;
      setTimeout(() => {
        this.scrolledToChallengeButton = true;
        setTimeout(() => {
          context.scrolledToChallengeButton = false;
        }, 1000);
      }, 600);
    },

    clearChallengeData() {
      this.$store.commit('MainModeBook/GET_QUESTION_LIST_SUCCESS', []);
      this.$store.commit('MainModeBook/GET_QUESTION_SUCCESS', {});
      this.$store.commit('MainModeBook/GET_BEFORE_CHALLENGE_SUCCESS', {});
      this.$store.commit('MainModeBook/GET_AFTER_CHALLENGE_SUCCESS', {});
    },

    clearPracticeData() {
      this.$store.commit('MainModeBook/GET_QUESTION_LIST_SUCCESS', []);
      this.$store.commit('MainModeBook/GET_QUESTION_SUCCESS', {});
      this.$store.commit('MainModeBook/GET_BEFORE_PRACTICE_SUCCESS', {});
      this.$store.commit('MainModeBook/GET_AFTER_PRACTICE_SUCCESS', {});
    },

    tempBookToMaster() {
      this.isShowBookMasterAchieved = true;
      triggerShoolPride();
    },

    tempCourseLevelUp() {
      this.isShowCourseLevelUp = true;
      triggerShoolPride();
    },

    closeFileDownloadTip() {
      this.$store.commit('MainModeBook/SET_IS_HIDE_FILE_DOWN_TIP_STATUS', true);
    },

    goToNextBook() {
      this.closeBookMasterAchieved();
      this.$router.push(`/course/${this.Book.courseId}/book/${this.Book.nextBookId}`);
    },

    goBackToCourse() {
      this.closeCourseLevelUp();
      this.$router.push(`/course/${this.Book.courseId}`);
    },

    getBooleanByCompare(a, b) {
      return a <= b;
    },

    getDurationStringText(second) {
      return getDurationString(second);
    },

    go2Mall() {
      this.$router.push(`/mall/${this.Book.cssClassName.replace('-', '')}`);
    },

    checkOutlineUpdates() {
      $('#exam-outline-updates').modal('show');
    },

    checkUpdatedBullet(readingId) {
      $('#exam-outline-updates').modal('hide');
      this.scrollToReading(readingId);
    },

    ///
    setPromiseGetClassRestriction() {
      this.promiseClassRestrictionCoursePageInfo = this.promiseFetchBook;
    },

    ///
    noAccessInfo() {
      if (this.isLockedByStudentWorkStatus) {
        Swal.fire({
          width: '400px',
          backdrop: false,
          icon: 'warning',
          title: `温馨提示`,
          text: '亲爱的学员，请先完成全部前置章节的作业提交以解锁当前章节～',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    checkStudentWorkStatusAndDoFunc(func) {
      return async (...args) => {
        if (this.isLockedByStudentWorkStatus) {
          this.noAccessInfo();
        } else {
          func(...args);
        }
      };
    },

    _mainModeBookCreated() {
      this.generatePDF = this.checkClassRestrictionAndDoFunc(this.generatePDF);
      this.promiseFetchBook = this.fetchBook();

      this.openPlayer = this.checkStudentWorkStatusAndDoFunc(this.openPlayer);
      this.selectVideoType = this.checkStudentWorkStatusAndDoFunc(this.selectVideoType);
      this.go2ClassicQuestionPractice = this.checkStudentWorkStatusAndDoFunc(
        this.go2ClassicQuestionPractice
      );
      this.go2Practice = this.checkStudentWorkStatusAndDoFunc(this.go2Practice);
      this.go2Challenge = this.checkStudentWorkStatusAndDoFunc(this.go2Challenge);
      this.openDownloadPanel = this.checkStudentWorkStatusAndDoFunc(this.openDownloadPanel);
    },

    async _mainModeBookMounted() {
      await this.promiseFetchBook;
      const context = this;
      setTimeout(() => {
        context.hideCurrentBtn = true;
      }, 15000);
      if (
        'true' !== localStorage.getItem('isShownLearnpathModal') &&
        this.$refs.btnLearnpathModals.length
      ) {
        localStorage.setItem('isShownLearnpathModal', 'true');
        $(this.$refs.learnpathModal).modal('show');
      }
      $('body').on('click', this.hidePopover);
      if (this.ms_isSetGotoLastStudy) {
        this.mm_SET_GOTO_LAST_STUDY(false);
        this.hideCurrentBtn = true;
        if (!this.$route.params.readingId && this.hasCurrentReading.isCurrent) {
          this.scrollToReading(this.hasCurrentReading.readingId);
        }
        setTimeout(() => {
          this.openLastTimeBullet();
        }, 500);
      }

      //if (!this.Book.freeMode && this.c_isNoAuth) {
      //  Swal.fire({
      //    icon: 'info',
      //    title: '您还没有认证',
      //    text: '亲爱的学员请先完成认证',
      //    confirmButtonColor: '#3085d6',
      //    confirmButtonText: '去认证',
      //    allowOutsideClick: false,
      //  }).then((result) => {
      //    if (result.value) {
      //      this.$router.push(IDENTITY_PAGE);
      //    }
      //  });
      //  return;
      //}
    },

    _mainModeBookBeforeDestroy() {
      $('#exam-outline-updates').modal('hide');
      $('body').off('click', this.hidePopover);
    },
  },
};
